import {
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Flex,
} from '@chakra-ui/react';
import { ServerError } from '../../../types';
import { ErrorsList } from '../ErrorsList';
import { fadeInScaleAnimation } from '@texas/resources/animations/animations';

export function ErrorDetails({ error }: { error: ServerError | null }) {
  if (!error) {
    return null;
  }

  return (
    <Alert marginBottom="4" status="error" animation={fadeInScaleAnimation()}>
      <AlertIcon />
      <Flex flexDir="column">
        <AlertTitle>{error.message}</AlertTitle>
        <AlertDescription>
          <ErrorsList errors={error.errors} />
        </AlertDescription>
      </Flex>
    </Alert>
  );
}
